import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '@/services/api'

const initialState = {
  stats: null,
  recentActivities: [],
  todos: [],
  pendingApprovals: null,
  departmentSummary: [],
  loading: false,
  error: null,
}

export const fetchDashboard = createAsyncThunk(
  'dashboard/fetchDashboard',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/dashboard/stats')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || '載入儀表板失敗')
    }
  }
)

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboard.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchDashboard.fulfilled, (state, action) => {
        state.loading = false
        const data = action.payload.data
        state.stats = data.stats || null
        state.recentActivities = data.recent_activities || []
        state.todos = data.todos || []
        state.pendingApprovals = data.pending_approvals || null
        state.departmentSummary = data.department_summary || []
      })
      .addCase(fetchDashboard.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { clearError } = dashboardSlice.actions
export default dashboardSlice.reducer
